import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=1a17179c&scoped=true"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"
import style0 from "./Widgets.vue?vue&type=style&index=0&id=1a17179c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a17179c",
  null
  
)

export default component.exports